

 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

export  const    sectionTheme1SectionCard1Object = { no:6, 
    id: generateTimestamp()+3,
    cardName:"T1SectionCard1",
    cardType:"non-Editable",
 myKey:`id-T1SectionCard1-layout`,
  blockType:"layout",
    contents:[
    { contentNo:1, id: generateTimestamp(),itemBackground:{color:"rgba(0, 0, 0, 1)",alpha:1}
          ,itemCards:{  type:"nonEditable"
            ,cards:[
                       ]},myKey:`id-T1SectionCard1-layout1-${generateTimestamp()+3}`,
          columns:1,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
  blockType:"Card",
 innerBlocks:[],

 customStyle:{
    
 },
 layoutSettings:{
    disableAnimation:false,
     shape1Animation:{title:"Shape Animation",type:"rhombusHL",delay:0.4,
        color: {color:"rgba(35, 36, 36, 0.93)",color1:"rgba(130, 242, 242, 0.93)",color2:"rgba(140, 177, 251, 0.93)",colors:{color10:"rgba(247, 252, 252, 0.93)"},alpha:1}
     ,},
      shape2Animation:{title:"Shape Animation",type:"rhombusHR",delay:0.4,
        color:{color:"rgba(255, 255, 255, 0.93)",color1:"rgba(130, 242, 242, 0.93)",color2:"rgba(140, 177, 251, 0.93)",colors:{color10:"rgba(247, 252, 252, 0.93)"},alpha:1}
     , },
     
     layoutWidth:{value:100,resolution:"%"},
    
     borderRadius1:{title:"Layout BG Radius",value:0,resolution:"px"},
    
     layoutBG:{ title:"Section Card Outer Color",
      color:"rgba(255, 224, 71, 1)",colors:{color3:"rgba(255, 224, 71, 0.3)",color10:"rgba(255, 224, 71, 1)"},alpha:1},
    
 }   },
        { contentNo:2, id: generateTimestamp()+1,itemBackground:{color:"rgba(144, 202, 249, 0.1)",alpha:1}

          ,itemCards:{  type:"nonEditable"
            ,cards:[
               { id: 1,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,  title: "1x1",subtitle: "Live Online Sessions", 
                image: "https://i.postimg.cc/t4YRDRbd/6390.jpg",
                video:{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           youtube:{src:"https://www.youtube.com/watch?v=qFLhGq0060w",
                           showDefaultThumbnail:true
                           ,useDefaultPlayer:false },
                            vimeo:{src:"https://vimeo.com/837164312"
                           ,useDefaultPlayer:false},
                            mp4URL:{src:"http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" },
                            uploadedVideoURL:{src:"" },
                            videoThumbnail:{
                                src:"https://i.postimg.cc/t4YRDRbd/6390.jpg",hideThumbnail:false,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:0,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }, },
              { id: 2,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,  title: "Personalized",subtitle: "Live Online Sessions", 
                image: "https://i.postimg.cc/HkNtgpwZ/6408.jpg" ,
               video:{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           youtube:{src:"https://www.youtube.com/watch?v=Bn-3ICGjz0U",
                           showDefaultThumbnail:true
                           ,useDefaultPlayer:false },
                            vimeo:{src:"https://vimeo.com/837164312"
                           ,useDefaultPlayer:false},
                            mp4URL:{src:"" },
                            uploadedVideoURL:{src:"" },
                            videoThumbnail:{
                                src:"",hideThumbnail:false,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:0,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       },},
              { id: 3,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,  title: "1x1",subtitle: "Live Online Sessions", 
                image: "https://i.postimg.cc/zGgZVy5Q/6388.jpg",
                video:{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           youtube:{src:"https://www.youtube.com/watch?v=UZwi9SHgzGY",
                           showDefaultThumbnail:true
                           ,useDefaultPlayer:false },
                            vimeo:{src:"https://vimeo.com/837164312",
                               showDefaultThumbnail:true
                          
                           ,useDefaultPlayer:false},
                            mp4URL:{src:"" },
                            uploadedVideoURL:{src:"" },
                            videoThumbnail:{
                                src:"https://i.postimg.cc/zGgZVy5Q/6388.jpg",hideThumbnail:false,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:0,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }, },
                  
                       ]},myKey:`id-T1SectionCard1-layout2-${generateTimestamp()+3}`,columns:4,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
  blockType:"images",
 customStyle:{
    
 },
 layoutSettings:{
   
    disableAnimation:false,
     layoutAnimation:{title:"Image Animation",type:"zoomIn",delay:0.4},
  item1Animation:{title:"Title   Animation",type:"goLeft",delay:0.4},
  item2Animation:{title:"Subtitle  Animation",type:"goRight",delay:0.4},
   item3Animation:{title:"Play Button  Animation",type:"spinRight",delay:0.4},
  item4Animation:{title:"Slide Number Animation",type:"spinLeft",delay:0.4},
  item5Animation:{title:"Slide Carousel Animation",type:"spinRight",delay:0.4},
  item6Animation:{title:"Text Card Animation",type:"zoomIn",delay:0.4},
   
     borderRadius1:{title:"SlideShow Image Radius",topLeft:{title:"Text Box Radius",value:150,resolution:"px"},
     topRight:{title:"Text Box Radius",value:10,resolution:"px"},
    bottomLeft:{title:"Text Box Radius",value:30,resolution:"px"},
    bottomRight:{title:"Text Box Radius",value:50,resolution:"px"}},
     borderRadius2:{title:"Play Button Radius",topLeft:{title:"Text Box Radius",value:50,resolution:"px"},topRight:{title:"Text Box Radius",value:50,resolution:"px"},
    bottomLeft:{title:"Text Box Radius",value:50,resolution:"px"},bottomRight:{title:"Text Box Radius",value:50,resolution:"px"}},
    borderRadius3:{title:"Image Navigator Radius",topLeft:{title:"Text Box Radius",value:0,resolution:"px"},topRight:{title:"Text Box Radius",value:10,resolution:"px"},
    bottomLeft:{title:"Text Box Radius",value:0,resolution:"px"},bottomRight:{title:"Text Box Radius",value:30,resolution:"px"}},
    layoutWidth:{title:"layout Width",value:100,resolution:"%"},

      item1Width:{title:"Play Button Width",value:100,resolution:"%"},
      //  item2Width:{title:"Text Width",value:100,resolution:"%"},
   
       layoutAspectRatio:{title:"Image Crop Ratio",value:"2/1"},
    // item1AspectRatio:{title:"Image 2 Crop Ratio",value:4/3},
    // item2AspectRatio:{title:"Image 2 Crop Ratio",value:4/3},
    layoutBorder:{title:"Image  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(255, 255, 255, 0.93)",colors:{},alpha:1}},
    item1Border:{title:"Play Button Border",borderType:"solid",borderWidth:{title:"Border Width",value:3,resolution:"px"},borderColor:{title:"Image Border Color",color:"rgba(255, 255, 255, 0.93)",colors:{},alpha:1}},
    item2Border:{title:"Images Carousel Border",borderType:"solid",borderWidth:{title:"Border Width",value:3,resolution:"px"},borderColor:{title:"Design 1 Border Color",color:"rgba(255, 255, 255, 0.93)",colors:{},alpha:1}},
    // flexDirection:"row",
    // gap:50,
    // flexWrap:"wrap",
    layoutBG:{title:"Layout Background Color",color:"rgba(252, 252, 93, 1)",colors:{color10:"rgba(242, 242, 74, 1)"},alpha:1},
     item1BG:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
        item2BG:{title:"Carousel & Play Btn BG Color",color:"rgba(252, 187, 74, 1)",colors:{color10:"rgba(252, 187, 74,1)"},alpha:1},
 titleEllipsis:{title:"Limit Title To One Line",status:true},
      subtitleEllipsis:{title:"Limit Subtitle To One Line",status:true},
     mirrorItems:{title:"Mirror Card Items",status:false},
    layoutShadow:{title:"Card Shadow",horizontal:{title:"Horizontal",value:0,resolution:"%"},vertical:{title:"Vertical",value:0,resolution:"%"},blur:{title:"Blur",value:0,resolution:"%"},spread:{title:"Spread",value:30,resolution:"%"},shadowColor:{title:"Image Shadow Color",color:"rgba(255, 255, 255, 0.23)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1},inset:false}
    ,item1Shadow:{title:"Image Shadow",horizontal:{title:"Horizontal",value:10,resolution:"%"},vertical:{title:"Horizontal",value:10,resolution:"%"},blur:{title:"Horizontal",value:10,resolution:"%"},spread:{title:"Horizontal",value:10,resolution:"%"},shadowColor:{title:"Design 1 Color",color:"rgba(255, 255, 255, 0.23)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1},inset:false}
    ,item2Shadow:{title:"Images Carousel  Shadow",horizontal:{title:"Horizontal",value:0,resolution:"%"},vertical:{title:"Horizontal",value:0,resolution:"%"},blur:{title:"Horizontal",value:0,resolution:"%"},spread:{title:"Horizontal",value:0,resolution:"%"},shadowColor:{title:"Design 1 Color",color:"rgba(255, 255, 255, 0.23)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1},inset:false}
,   

        margin:{
  title:"Set Image Layout  Margin",
  marginTop:{title:"Top Margin",value:130,resolution:"px"},
  marginLeft:{title:"Left Margin",value:0,resolution:"px"},
  marginRight:{title:"Right Margin",value:0,resolution:"px"},
  marginBottom:{title:"Bottom Margin",value:30,resolution:"px"}},
marginItem1:{ title:"Set Title Margin",
  marginTop:{title:"Top Margin",value:1,resolution:"px"},
  marginLeft:{title:"Left Margin",value:15,resolution:"px"},
  marginRight:{title:"Right Margin",value:50,resolution:"px"},
  marginBottom:{title:"Bottom Margin",value:40,resolution:"px"}},

// marginItem2:{ title:"Set Text Margin",
//   marginTop:{title:"Top Margin",value:30,resolution:"px"},
//   marginLeft:{title:"Left Margin",value:10,resolution:"px"},
//   marginBottom:{title:"Bottom Margin",value:10,resolution:"px"}},


  padding:{
       title:"Set Layout Padding",
      paddingTop:{title:"Top Padding",value:30,resolution:"px"},
  paddingLeft:{title:"Left Padding",value:30,resolution:"px"},
  paddingRight:{title:"Right Padding",value:30,resolution:"px"},
  paddingBottom:{title:"Bottom Padding",value:30,resolution:"px"}},

// paddingItem1:{ title:"Set Design 1 Padding",
//   paddingTop:{title:"Top Padding",value:20,resolution:"px"},
//   paddingLeft:{title:"Left Padding",value:20,resolution:"px"},
//   paddingRight:{title:"Right Padding",value:20,resolution:"px"},
//   paddingBottom:{title:"Bottom Padding",value:20,resolution:"px"}},
// paddingItem2:{ title:"Set Text & Image Wrapper Padding",
//   paddingTop:{title:"Top Padding",value:1,resolution:"px"},
//   paddingLeft:{title:"Left Padding",value:1,resolution:"px"},
//   paddingBottom:{title:"Bottom Padding",value:1,resolution:"px"}},
 
 typographyTitle:{
         titleColor:{title:"Title Text Color",color:"rgba(245, 236, 236, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
    
        size:{title:"Title Text Font Size",value:60,resolution:"px"},
        family:{name:"OpenSans-Regular",
    fontFamily:"OpenSansRegular , sans-serif"
       },
        weight:{title:"Title Text Font Weight",fontWeight:"900"},
        textAlignment:{title:"Title Text Alignment",textAlign:"left"},
        textCase:{title:"Title Text Case",textTransform:"uppercase"},
       textStyle:{title:"Title  Text Style",textStyle:"normal"},
       decoration:{title:"Title Text Decoration",line:"none",style:"wavy", decorationColor :{title:"Title Text Decoration Color",color:"rgba(246, 240, 240, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},thickness:{title:"Title Text Decoration Thickness",value:5,resolution:"px"}},
       lineHeight:{title:"Title Text Line Height",value:70,resolution:"px"},
       letterSpacing:{title:"Title Text Letter Spacing",value:3,resolution:"px"},
       wordSpacing:{title:"Title Text Word Spacing",value:5,resolution:"px"},
       textStroke:{ 
         strokeColor:{title:"Title Text Stroke Color",color:"rgba(41, 40, 40, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
         strokeSize:{title:"Title Text Stroke Size",value:0,resolution:"px"},
       
              } ,
                  textShadow:{title:"Title  Text Shadow",horizontal:{title:"Title Shadow Horizontal",value:10,resolution:"%"},vertical:{title:"Title Shadow Vertical",value:10,resolution:"%"},blur:{title:"Title Shadow Blur",value:10,resolution:"%"},spread:{title:"Title Shadow Spread",value:10,resolution:"%"},shadowColor:{title:"Title Shadow Color",color:"rgba(221, 253, 253, 0.93)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1}}   
        
    }
    ,typographySubtitle:{
         titleColor:{title:"SubtTitle Text Color",color:"rgba(19, 19, 19, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
    
        size:{title:"SubtTitle Text Font Size",value:20,resolution:"px"},
        family:{name:"OpenSans-Regular",
    fontFamily:"OpenSansRegular , sans-serif"
       },
        weight:{title:"Title Text Font Weight",fontWeight:"500"},
        textAlignment:{title:"Title Text Alignment",textAlign:"left"},
        textCase:{title:"Title Text Case",textTransform:"uppercase"},
       textStyle:{title:"Title  Text Style",textStyle:"normal"},
      decoration:{title:"Subtitle Text Decoration",line:"none",style:"wavy", decorationColor :{title:"Subtitle  Text Decoration Color",color:"rgba(19, 19, 19, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},thickness:{title:"Subtitle  Text Decoration Thickness",value:2,resolution:"px"}},
       lineHeight:{title:"Title Text Line Height",value:30,resolution:"px"},
       letterSpacing:{title:"Title Text Letter Spacing",value:1,resolution:"px"},
       wordSpacing:{title:"Title Text Word Spacing",value:2,resolution:"px"},
       textStroke:{ 
         strokeColor:{title:"Title Text Stroke Color",color:"rgba(19, 19, 19, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
         strokeSize:{title:"Title Text Stroke Size",value:0,resolution:"px"},
       
              } ,
                  textShadow:{title:"Title  Text Shadow",horizontal:{title:"Title Shadow Horizontal",value:10,resolution:"%"},vertical:{title:"Title Shadow Vertical",value:10,resolution:"%"},blur:{title:"Title Shadow Blur",value:10,resolution:"%"},spread:{title:"Title Shadow Spread",value:10,resolution:"%"},shadowColor:{title:"Title Shadow Color",color:"rgba(221, 253, 253, 0.93)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1}}   
        
    }
    
    
 },  }



],
        
        }